export const START = 'START';
export const PRO = 'PRO';
export const VR = 'VR';
export const ALL_TARIFFS = [START, PRO, VR];

export const pro = 'pro';
export const proplus = 'proplus';
export const businessvr = 'businessvr';
